import { render, staticRenderFns } from "./text-box-percent.vue?vue&type=template&id=bdb67e60&"
import script from "./text-box-percent.vue?vue&type=script&lang=js&"
export * from "./text-box-percent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports